import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { BaseService } from '@essent/common';
import { snakeCase, toHttpParams } from '@essent/common';
import { API_PUBLIC_PREFIX } from '@core/config-angular';
import type { Observable } from 'rxjs';
import {
  type InsulationNewCustomerAddressCheckRequestQuery,
  type InsulationNewCustomerAddressCheckResponseV1,
} from '@innogy/feh/models';

@Injectable()
export class GetInsulationAddressCheckService
  implements
    BaseService<
      InsulationNewCustomerAddressCheckRequestQuery,
      InsulationNewCustomerAddressCheckResponseV1
    >
{
  private readonly apiUrl: string | null = inject(API_PUBLIC_PREFIX, {
    optional: true,
  });
  private readonly httpClient = inject(HttpClient);

  public readonly apiVersion = '1';
  public readonly endpoint = `${
    this.apiUrl || ''
  }/feh/leads/insulation/get-address-info/v${this.apiVersion}`;

  public call$(
    payload: InsulationNewCustomerAddressCheckRequestQuery
  ): Observable<InsulationNewCustomerAddressCheckResponseV1> {
    const headers = { Accept: 'application/json' };

    const params = toHttpParams(snakeCase(payload));

    return this.httpClient.get<InsulationNewCustomerAddressCheckResponseV1>(
      this.endpoint,
      { headers, params }
    );
  }
}
